import React from 'react';
import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import MarkAppDashboard from './components/MarkAppDashboard';
import Login from './components/Auth/Login';
import Signup from './components/Auth/Signup';
import VerifyCode from './components/Auth/VerifyCode';
import PaymentSuccess from './components/PaymentSuccess';
import HelpPage from './components/HelpPage';
import './App.css';
import { NetworkStatusProvider } from './context/NetworkStatusContext';

function ProtectedRoute({ children }) {
  const token = localStorage.getItem('access_token');

  if (!token) {
    return <Navigate to="/login" replace />;
  }

  return children;
        }

function PublicRoute({ children }) {
    const token = localStorage.getItem('access_token');

  if (token) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function NavigationLogger() {
  const location = useLocation();

  React.useEffect(() => {
    console.debug(`📍 Навигация: ${location.pathname}`);
  }, [location]);

    return null;
  }

function App() {
  return (
    <NetworkStatusProvider>
      <BrowserRouter>
      <NavigationLogger />
      <Routes>
        <Route
          path="/login"
          element={(
            <PublicRoute>
              <Login />
            </PublicRoute>
          )}
        />
        <Route
          path="/signup"
          element={(
            <PublicRoute>
              <Signup />
            </PublicRoute>
          )}
        />
        <Route
          path="/verify"
          element={(
            <PublicRoute>
              <VerifyCode />
            </PublicRoute>
          )}
        />
        <Route
          path="/"
          element={(
            <ProtectedRoute>
      <MarkAppDashboard />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/payment/success"
          element={(
            <ProtectedRoute>
              <PaymentSuccess />
            </ProtectedRoute>
          )}
        />
        <Route
          path="/help"
          element={<HelpPage />}
        />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </BrowserRouter>
    </NetworkStatusProvider>
  );
}

export default App;
